<template>
  <div class="cert-manager" v-loading="loading">
    <div class="toolbar" v-if="canManage">
      <el-button
        v-if="!showForm"
        type="primary"
        icon="el-icon-plus"
        size="small"
        @click="openCreateForm">
        Add new analysis
      </el-button>
    </div>

    <certification-form
      v-if="showForm"
      :station="station"
      :certification="editingCertification"
      :editing="!!editingCertification"
      @created="onSaved"
      @updated="onSaved"
      @cancel="closeForm" />

    <div v-if="!showForm" class="history">
      <div v-if="!loading && certifications.length === 0" class="empty">
        No certifications recorded yet.
      </div>

      <certification-row
        v-for="cert in certifications"
        :key="cert.id"
        :certification="cert"
        :canManage="canManage"
        @edit="openEditForm"
        @delete="confirmDelete" />
    </div>
  </div>
</template>

<script>
import CertificationRow from './CertificationRow'
import CertificationForm from './CertificationForm'

export default {
  name: 'CertificationManager',
  components: { CertificationRow, CertificationForm },
  props: {
    station: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: true,
      certifications: [],
      showForm: false,
      editingCertification: null
    }
  },
  computed: {
    canManage () {
      if (this.$auth.user.isSystem) return true
      if (!this.station.organization) return false
      const userOrgs = (this.$root && this.$root.userOrganizations) || []
      return userOrgs.some(uo =>
        uo.organization &&
        uo.organization.id === this.station.organization.id &&
        uo.isOrganizationAdmin
      )
    }
  },
  methods: {
    async fetchCertifications () {
      this.loading = true
      try {
        const url = this.$api.station(this.$route.params.sId).certifications
        const response = await this.$http.get(url)
        this.certifications = Array.isArray(response.data) ? response.data : []
      } catch (e) {
        this.certifications = []
      } finally {
        this.loading = false
      }
    },
    openCreateForm () {
      this.editingCertification = null
      this.showForm = true
    },
    openEditForm (certification) {
      this.editingCertification = certification
      this.showForm = true
    },
    closeForm () {
      this.showForm = false
      this.editingCertification = null
    },
    async onSaved () {
      this.closeForm()
      await this.fetchCertifications()
      this.$emit('refresh')
    },
    confirmDelete (certification) {
      this.$confirm(
        `Delete the certification from ${this.formatDate(certification.certifiedAt)}? This cannot be undone.`,
        'Are you sure?',
        {
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      ).then(async () => {
        try {
          const url = this.$api.station(this.$route.params.sId).certification(certification.id).remove
          await this.$http.delete(url)
          this.$message.success('Certification deleted')
          await this.fetchCertifications()
          this.$emit('refresh')
        } catch (e) {
          this.$message.error('Could not delete certification')
        }
      }).catch(() => {})
    },
    formatDate (value) {
      if (!value) return ''
      const d = new Date(value)
      if (isNaN(d.getTime())) return value
      return d.toLocaleDateString()
    }
  },
  created () {
    this.fetchCertifications()
  }
}
</script>

<style lang="scss" scoped>
  .cert-manager {
    min-height: 200px;
  }

  .toolbar {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  .history {
    margin-top: 10px;
  }

  .empty {
    color: $text-light;
    font-size: 12px;
    text-align: center;
    padding: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/stations/station/Certification/CertificationManager.vue